import * as actionTypes from "Redux/Actions/actionTypes";

const resetStore = () => {
  return {
    type: actionTypes.RESET_STORE_REQUEST,
  };
};

export default resetStore;
